import { NON_NUM_RE, RegNumberFormItems } from './shared';

export class NesaFormItems extends RegNumberFormItems {
  static slug = 'nesa'

  static placeholder = '123456'

  static regNumberGetValueFromEvent(evt) {
    return evt.target.value.substr(0, 6).replace(NON_NUM_RE, '');
  }
}
